import { apiClient } from 'modules/core/lib/mobx-rest'

import { PayrollIntegrationType } from 'modules/payroll_integrations/lib/catalog'

export enum Status {
  Unavailable = 'unavailable',
  Available = 'available',
  Done = 'done',
  Pending = 'pending',
  Blocked = 'blocked',
}

export interface Diff {
  local: string
  remote: string
}

export interface DiffFields {
  first_name?: Diff
  last_name?: Diff
  identifier_number?: Diff
  identifier_type?: Diff
  social_security_number?: Diff
}

export interface Sync {
  integration: string
  status: Status
  error_code: string | null
  error_message?: string | null
  unavailable_fields: string[] | null
  diff_fields: DiffFields | null
  unsync_fields: string[] | null
  syncable_fields: string[] | null
  pending_over_24h?: boolean | undefined
}

export interface SyncEmployeeCode {
  integration: string
  synced: boolean
}

interface StatusParams {
  companyId?: string
  incidenceId: string
  integration: PayrollIntegrationType
  isBookkeeperView: boolean
}

interface SyncParams {
  companyId?: string
  incidenceId: string
  integration: PayrollIntegrationType
  isBookkeeperView: boolean
}

class IncidenceSync {
  static syncPath = '/payroll_integrations/syncs'

  async status(params: StatusParams): Promise<Sync> {
    return apiClient().get(IncidenceSync.syncPath, {
      company_id: params.companyId,
      bookkeeper_view: params.isBookkeeperView,
      incidence_id: params.incidenceId,
      integration: params.integration,
    })
  }

  async sync(params: SyncParams): Promise<Sync> {
    return apiClient().post(IncidenceSync.syncPath, {
      company_id: params.companyId,
      bookkeeper_view: params.isBookkeeperView,
      incidence_id: params.incidenceId,
      integration: params.integration,
    })
  }
}

export default new IncidenceSync()
